export const getRowCount = (totalItems: number, columnCount: number) =>
  Math.ceil(totalItems / columnCount);
